import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideoPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 33 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M29.1533 13.2665L13.2567 1.60986C12.0151 0.700664 10.5459 0.153043 9.01212 0.0276936C7.47831 -0.0976555 5.93976 0.204164 4.56699 0.899695C3.19422 1.59523 2.04086 2.6573 1.23475 3.9682C0.428638 5.2791 0.00126858 6.78761 1.00565e-05 8.32652V31.6515C-0.0023841 33.1919 0.422751 34.7028 1.22809 36.0159C2.03343 37.3291 3.18739 38.393 4.5615 39.0892C5.93561 39.7854 7.47598 40.0866 9.01113 39.9593C10.5463 39.832 12.016 39.2812 13.2567 38.3682L29.1533 26.7115C30.2081 25.9374 31.0659 24.9259 31.6571 23.7587C32.2483 22.5915 32.5563 21.3015 32.5563 19.9932C32.5563 18.6848 32.2483 17.3949 31.6571 16.2277C31.0659 15.0605 30.2081 14.0489 29.1533 13.2749V13.2665Z",
		fill: "currentColor"
	})
});
export default SvgVideoPlay;
